import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";

import { Link } from "react-router";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";

class Index extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Shortlinks"} tKey={"shortlinks.pagetitle"} />} />

        <GridContainer>
          <GridItem xs={12}>
            <AuthenticationWrapper permissionKey={"shortlinks.create"}>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />{" "}
                  <TranslationWrapper tDefault={"Nieuwe shortlink"} tKey={"shortlinks.nieuw.item"} />
                </Button>
              </Link>
            </AuthenticationWrapper>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "vestiging.systeemNaam", editable: false },
                { dbfield: "shortlink", editable: true, inputtype: "Input" },
                { dbfield: "tafel.naam", editable: false },
                { dbfield: "is_actief", editable: true, inputtype: "Switch" },
              ]}
              editLink={"./:id/edit"}
              editLinkPermission={"shortlinks/:id/edit"}
              fetchUrl={"core/shortlinks"}
              filters={this.props.filters}
              headerIcon={<LinkIcon />}
              headers={[
                {
                  label: getTranslation("shortlinks.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("shortlinks.table.verkoopgebied", "Verkoopgebied"),
                  sortable: true,
                  sortKey: "vestiging.systeemNaam",
                },
                {
                  label: getTranslation("shortlinks.table.from", "Van"),
                  sortable: true,
                  sortKey: "shortlink",
                },
                {
                  label: getTranslation("shortlinks.table.to", "Naar"),
                  sortable: true,
                  sortKey: "tafel.naam",
                },
                {
                  label: getTranslation("shortlinks.table.is_actief", "Actief"),
                  sortable: false,
                },
              ]}
              reduxKey={"shortlinks"}
              tableTitle={<TranslationWrapper tDefault={"Shortlinks"} tKey={"shortlinks.table.titel"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  return {
    filters: getVestigingFilterState(state, true),
  };
};

export default connect(mapStateToProps)(withStyles(Index, vestigingStyle));
